// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rafzi{line-height:160%;letter-spacing:0;font-weight:700;font-size:16px}.MmEXi{margin-bottom:5px}.TLwkc{border-radius:15px !important;border:1px solid #e2e8f0;font-size:16px;padding:12px 16px 12px 16px !important}html,body{overflow-x:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `Rafzi`,
	"inputLabel": `MmEXi`,
	"inputField": `TLwkc`
};
module.exports = ___CSS_LOADER_EXPORT___;
